(function () {
  function getVideoContainer(video) {
    return video.closest('[data-hero-video-container], .hero-section-banner__video-container');
  }

  function isVideoVisible(video) {
    if (video.classList.contains('hero-section-banner__video--mobile')) {
      return window.matchMedia('(max-width: 768px)').matches;
    }
    if (video.classList.contains('hero-section-banner__video--desktop')) {
      return window.matchMedia('(min-width: 769px)').matches;
    }
    return true;
  }

  function getVisibleVideo(container) {
    if (!container) return null;
    return Array.from(container.querySelectorAll('[data-hero-video]')).find(isVideoVisible) || null;
  }

  function hidePosterWhenVideoReady(video) {
    const container = getVideoContainer(video);
    if (!container || container.classList.contains('is-video-playing')) return;

    function markVideoPlaying() {
      if (container.classList.contains('is-video-playing')) return;
      container.classList.add('is-video-playing');
    }

    if (video.readyState >= 2 && !video.paused && video.currentTime > 0) {
      markVideoPlaying();
      return;
    }

    let done = false;

    function finish() {
      if (done) return;
      done = true;
      markVideoPlaying();
    }

    if (typeof video.requestVideoFrameCallback === 'function') {
      video.requestVideoFrameCallback(finish);
    }

    function onTimeUpdate() {
      if (video.readyState >= 2 && video.currentTime > 0) {
        video.removeEventListener('timeupdate', onTimeUpdate);
        finish();
      }
    }

    video.addEventListener('timeupdate', onTimeUpdate);
  }

  function bindVideoPlayingState(video) {
    if (video.dataset.heroVideoPlayingBound === 'true') return;
    video.dataset.heroVideoPlayingBound = 'true';

    video.addEventListener('playing', function () {
      hidePosterWhenVideoReady(video);
    });
  }

  function playHeroVideo(video) {
    if (video.readyState === 0) {
      video.load();
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function shouldDeferFirstVideo(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides) return false;
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (!activeSlide) return false;

    const deferredContainer = activeSlide.querySelector('[data-defer-first-video="true"]');
    return Boolean(deferredContainer) && window.__heroFirstVideoReady !== true;
  }

  function initHeroBannerSlider(sliderEl) {
    if (!sliderEl || typeof Swiper === 'undefined') return;

    const slideCount = parseInt(sliderEl.dataset.slideCount, 10) || 0;
    const enableAutoplay = sliderEl.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(sliderEl.dataset.autoplayDelay, 10) || 5000;
    const showPagination = sliderEl.dataset.showPagination === 'true';

    const swiperConfig = {
      loop: slideCount > 1,
      speed: 800,
      slidesPerView: 1,
      effect: 'slide',
      watchOverflow: true,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        nextEl: sliderEl.querySelector('[data-hero-next]'),
        prevEl: sliderEl.querySelector('[data-hero-prev]'),
        disabledClass: 'swiper-button-disabled',
      },
      on: {
        init: function () {
          handleSlideVideos(this);
        },
        slideChange: function () {
          handleSlideVideos(this);
        },
      },
    };

    if (showPagination && slideCount > 1) {
      swiperConfig.pagination = {
        el: sliderEl.querySelector('.hero-section-banner__pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<button type="button" class="' +
            className +
            '" aria-label="Go to slide ' +
            (index + 1) +
            '"></button>'
          );
        },
      };
    }

    if (enableAutoplay && slideCount > 1) {
      swiperConfig.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    const heroSwiper = new Swiper(sliderEl, swiperConfig);

    function getActiveVideos(swiperInstance) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return [];

      return Array.from(activeSlide.querySelectorAll('[data-hero-video]')).filter(isVideoVisible);
    }

    function pauseAllVideos(exceptVideos) {
      const exceptSet = new Set(exceptVideos || []);
      sliderEl.querySelectorAll('[data-hero-video]').forEach(function (video) {
        if (!exceptSet.has(video)) {
          video.pause();
        }
      });
    }

    function syncVideoToggleState(video) {
      const container = getVideoContainer(video);
      if (!container) return;

      const toggle = container.querySelector('[data-hero-video-toggle]');
      if (!toggle) return;

      const isPaused = video.paused;
      toggle.classList.toggle('is-paused', isPaused);
      toggle.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');

      const toggleText = toggle.querySelector('[data-hero-video-toggle-text]');
      if (toggleText) {
        toggleText.textContent = isPaused ? 'Play video' : 'Pause video';
      }
    }

    function handleSlideVideos(swiperInstance) {
      if (shouldDeferFirstVideo(swiperInstance)) {
        pauseAllVideos([]);
        return;
      }

      const activeVideos = getActiveVideos(swiperInstance);
      pauseAllVideos(activeVideos);

      activeVideos.forEach(function (video) {
        playHeroVideo(video);
        syncVideoToggleState(video);
      });
    }

    sliderEl.querySelectorAll('[data-hero-video-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const container = toggle.closest('.hero-section-banner__video-container');
        if (!container) return;

        const video = getVisibleVideo(container);
        if (!video) return;

        if (video.paused) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }

        syncVideoToggleState(video);
      });
    });

    sliderEl.querySelectorAll('[data-hero-video]').forEach(function (video) {
      bindVideoPlayingState(video);
      video.addEventListener('play', function () {
        syncVideoToggleState(video);
      });
      video.addEventListener('pause', function () {
        syncVideoToggleState(video);
      });
    });

    window.addEventListener('resize', function () {
      handleSlideVideos(heroSwiper);
    });

    if (document.readyState === 'complete') {
      window.__heroFirstVideoReady = true;
      handleSlideVideos(heroSwiper);
    } else {
      window.addEventListener(
        'load',
        function () {
          window.__heroFirstVideoReady = true;
          handleSlideVideos(heroSwiper);
        },
        { once: true }
      );
    }
  }

  function initAllHeroBannerSliders() {
    document.querySelectorAll('[data-hero-banner-slider]').forEach(initHeroBannerSlider);
  }

  function scheduleHeroBannerInit() {
    if (typeof Swiper === 'undefined') {
      window.requestAnimationFrame(scheduleHeroBannerInit);
      return;
    }
    initAllHeroBannerSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHeroBannerInit);
  } else {
    scheduleHeroBannerInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sliderEl = event.target.querySelector('[data-hero-banner-slider]');
    if (!sliderEl) return;

    if (typeof Swiper === 'undefined') {
      window.requestAnimationFrame(function retry() {
        if (typeof Swiper === 'undefined') {
          window.requestAnimationFrame(retry);
          return;
        }
        initHeroBannerSlider(sliderEl);
      });
      return;
    }

    initHeroBannerSlider(sliderEl);
  });
})();
